<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="descricao"
    :label="label"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    @click="onClick"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import NotaService from '@/api/nota-entrada-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    label: {
      type: String,
      default: 'Tipo de Nota de Entrada',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.debounceSearch();
        }
      },
    },
  },
  methods: {
    searchItems(val) {
      const isSelected = this.localValue && this.localValue.descricao === val;

      if (isSelected) {
        return;
      }

      const searchValue = isSelected || !val ? '' : val;

      this.loading = true;
      NotaService.getNotasPage({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `descricao like "%${searchValue.toLowerCase()}%" or codigoInterno like "%${searchValue.toLowerCase()}%"`,
      })
        .then((response) => {
          if (this.value) {
            this.items = [this.value, ...response.data.content];
          }
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus(event) {
      this.debounceSearch(null);
      this.$emit('focus', event);
    },
    onClick(event) {
      this.$emit('click', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchItems, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
